import {api, graph2, graph_vars, graph_vars_str} from '../utils/shared'

export const baskets = async(token, fields, vars=[]) => {

    let p = graph_vars_str(vars)

    let vparams = p[0]
    let qparams = p[1]
    let j_params = p[2]

    let q = `query ${vparams} {
            agent_sessions ${qparams}
            {
                result
                    {
                        ${fields}
                    }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`

    let x = await graph_vars(q, j_params, token)
    return x
}

export const basketCount = async(token, vars=[]) => {

    let p = graph_vars_str(vars)

    let vparams = p[0]
    let qparams = p[1]
    let j_params = p[2]

    let q = `query agent_session_count ${vparams} {
            agent_session_count ${qparams}
            {
                result
            error {
			    ... on Unexpected_Error {
				message
			}
		}
    }
    }`

    let x = await graph_vars(q, j_params, token)
    return x
}

export const agent_session_from_reference = async(token, fields, reference) => {

    let vars = []
    vars.push({"param_var_name": "$reference", "param_name": "reference", "param_type": "String!", "value": reference})
    let p = graph_vars_str(vars)

    let vparams = p[0]
    let qparams = p[1]
    let j_params = p[2]

    let q = `query ${vparams} {
            agent_session_from_reference ${qparams}
            {
                result
                    {
                        ${fields}
                    }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`

    let x = await graph_vars(q, j_params, token)
    return x
}

export const agent_session_rooms_reference = async(reference, fields, token) => {
    let q = `{
        agent_session_rooms_reference(reference: "${reference}")
        {
        result
        {
			${fields}
        }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`
    let x = await graph2(q, token)
    return x
}

export const agent_session_flight_reference = async(product_id, reference, fields, token) => {
    let q = `{
        agent_session_flight_reference(product_id: ${product_id}, reference: "${reference}")
        {
        result
        {
			${fields}
        }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`
    let x = await graph2(q, token)
    return x
}

export const agent_session_flight_extras_reference = async(reference, fields, token) => {
    let q = `{
        agent_session_flight_extras_reference(reference: "${reference}")
        {
        result
        {
			${fields}
        }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`
    let x = await graph2(q, token)
    return x
}

export const agent_session_transfer_reference = async(product_id, reference, fields, token) => {
    let q = `{
        agent_session_transfer_reference(product_id: ${product_id}, reference: "${reference}")
        {
        result
        {
			${fields}
        }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`
    let x = await graph2(q, token)
    return x
}

export const agent_session_package_reference = async(reference, fields, token) => {
    let q = `{
        agent_session_package_reference(reference: "${reference}")
        {
        result
        {
			${fields}
        }
        error {
			... on Unexpected_Error {
				message
			}
		}
    }
    }`
    let x = await graph2(q, token)
    return x
}

export const session_count = async(client_id, agent_id, date_from=null, date_to=null, type=null, token) => {
    return new Promise(async (resolve, reject) => {

        const pd = {
            "date_from": date_from,
            "date_to": date_to,
            "type": type, 
            "agent_id": agent_id,
        }
        if(client_id != null){
            pd["client_id"] = client_id
        }
        await api(
            "/session_count_agent/", pd,
            "POST",
            (d) => {
                d.json().then((result) => {
                    resolve(result);
                });
            },
            (e) => console.log(e), token, process.env.REACT_APP_STATS_URL
        );
    });
}

export const session_count_by_month = async(client_id, agent_id, date_from=null, date_to=null, type=null, token) => {
    return new Promise(async (resolve, reject) => {

        const pd = {
            "date_from": date_from,
            "date_to": date_to,
            "type": type, 
            "agent_id": agent_id,
        }
        if(client_id != null){
            pd["client_id"] = client_id
        }
        await api(
            "/session_count_by_month_agent/", pd,
            "POST",
            (d) => {
                d.json().then((result) => {
                    resolve(result);
                });
            },
            (e) => console.log(e), token, process.env.REACT_APP_STATS_URL
        );
    });
}

export const session_average_cost = async(client_id, agent_id, date_from=null, date_to=null, type=null, token) => {
    return new Promise(async (resolve, reject) => {

        const pd = {
            "date_from": date_from,
            "date_to": date_to,
            "type": type, 
            "agent_id": agent_id,
        }
        if(client_id != null){
            pd["client_id"] = client_id
        }
        await api(
            "/session_average_cost_agent/", pd,
            "POST",
            (d) => {
                d.json().then((result) => {
                    resolve(result);
                });
            },
            (e) => console.log(e), token, process.env.REACT_APP_STATS_URL
        );
    });
}

export const session_total_cost = async(client_id, agent_id, date_from=null, date_to=null, type=null, token) => {
    return new Promise(async (resolve, reject) => {

        const pd = {
            "date_from": date_from,
            "date_to": date_to,
            "type": type, 
            "agent_id": agent_id,
        }
        if(client_id != null){
            pd["client_id"] = client_id
        }
        await api(
            "/session_total_cost_agent/", pd,
            "POST",
            (d) => {
                d.json().then((result) => {
                    resolve(result);
                });
            },
            (e) => console.log(e), token, process.env.REACT_APP_STATS_URL
        );
    });
}
